/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import CaretDown from "@monsma/XDL/Icons/CaretDown";
import { xBaseTheme } from "@monsma/XDL/types";
import { styledScrollbar } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            background: ${getColor("common.background")};
            border: 1px solid ${getColor("common.ui12")};
            .accordionSectionsWrapper {
                border-top: 1px solid ${getColor("common.ui12")};
                &:first-child {
                    border-top-width: 0;
                }
            }
        `,
    },
    sectionDefaultProps: {
        headerProps: {
            css: css`
                button {
                    background: inherit;
                    padding: 15px;
                    border-width: 0;
                    &:focus {
                        border-width: 0;
                        padding: 15px;
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                border: none;
                padding: 20px;
                overflow: visible;
                ${styledScrollbar};
            `,
        },
        toggleIconProps: {
            src: CaretDown,
            size: 13,
            color: "common.ui10",
            css: css`
                margin-left: 5px;
            `,
        },
    },
} as xBaseTheme["accordion"];
